<template>
    <div class="monthly-distribution">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="mb-0">{{ $t("monthly_distribution") }}</h6>
                <button class="btn btn-sm btn-outline-secondary" @click="resetToEqual">
                    {{ $t("reset_equal") }}
                </button>
            </div>
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-12">
                        <small class="text-muted">
                            {{ $t("distribution_hint") }}
                        </small>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-lg-4 col-xl-3 mb-2" v-for="dist in localDistributions" :key="dist.month">
                        <div class="input-group input-group-sm">
                            <span class="input-group-text" style="width: 80px;">
                                {{ getMonthName(dist.month) }}
                            </span>
                            <input type="number" step="0.01" min="0" max="100"
                                class="form-control" v-model.number="dist.percentage"
                                @input="onPercentageChange">
                            <span class="input-group-text">%</span>
                        </div>
                        <small class="text-muted">
                            {{ formatNumber(calculateMonthTarget(dist.percentage)) }} kWh
                        </small>
                    </div>
                </div>

                <!-- Summen-Anzeige -->
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="alert" :class="totalValid ? 'alert-success' : 'alert-warning'">
                            <strong>{{ $t("total") }}:</strong>
                            {{ totalPercentage.toFixed(2) }}%
                            <span v-if="!totalValid" class="ms-2">
                                ({{ $t("should_be_100") }})
                            </span>
                            <span class="ms-3">|</span>
                            <span class="ms-3">
                                <strong>{{ $t("annual_target") }}:</strong>
                                {{ formatNumber(annualTarget) }} kWh
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MonthlyDistribution',
    props: {
        distributions: {
            type: Array,
            default: () => []
        },
        annualTarget: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            localDistributions: []
        }
    },
    watch: {
        distributions: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.localDistributions = JSON.parse(JSON.stringify(newVal))
                } else {
                    this.initializeDefault()
                }
            },
            immediate: true
        }
    },
    computed: {
        totalPercentage() {
            return this.localDistributions.reduce((sum, d) => sum + (parseFloat(d.percentage) || 0), 0)
        },
        totalValid() {
            return Math.abs(this.totalPercentage - 100) < 0.1
        }
    },
    methods: {
        initializeDefault() {
            this.localDistributions = []
            for (let month = 1; month <= 12; month++) {
                this.localDistributions.push({
                    month: month,
                    percentage: 8.33
                })
            }
        },
        getMonthName(month) {
            const monthNames = [
                'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
                'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
            ]
            return monthNames[month - 1]
        },
        calculateMonthTarget(percentage) {
            return this.annualTarget * (parseFloat(percentage) || 0) / 100
        },
        formatNumber(value) {
            return new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 0
            }).format(value)
        },
        onPercentageChange() {
            this.$emit('updateDistributions', this.localDistributions)
        },
        resetToEqual() {
            this.localDistributions.forEach(d => {
                d.percentage = 8.33
            })
            // Korrigiere den letzten Monat für exakt 100%
            this.localDistributions[11].percentage = 8.37
            this.$emit('updateDistributions', this.localDistributions)
        }
    }
}
</script>

<style scoped>
.input-group-text {
    font-size: 0.85rem;
}
</style>
